export default function Footer() {
  const year = new Date().getFullYear();
  const links = [
    { label: "排行榜", href: "#ranking" },
    { label: "高分神作", href: "#highscore" },
    { label: "分类推荐", href: "#genres" },
    { label: "人气新作", href: "#newrelease" },
    { label: "必看经典", href: "#classic" },
    { label: "常见问题", href: "#faq" },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100/80">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-label text-xl text-foreground-900">漫游榜单</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              好看的韩国漫画排行榜、评分高人气榜与必看榜一站式整理，帮你告别书荒，快速锁定值得追的精品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-arrow-right-s-line text-primary-500"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">联系我们</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              有冷门好作品想推荐，或对榜单有任何建议？
            </p>
            <a
              href="mailto:hello@manyoubangdan.example"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line"></i> hello@manyoubangdan.example
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 漫游榜单 · 好看的韩国漫画推荐平台
          </p>
          <p className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600">回到顶部</a>
            <a href="#faq" className="hover:text-primary-600">帮助中心</a>
          </p>
        </div>
      </div>
    </footer>
  );
}